/* Elocuencia — mejoras progresivas.
   Todo lo esencial (anadir al carrito, navegar, pagar) funciona sin este
   archivo; aqui solo se anade comodidad. */

(function () {
  'use strict';

  /* --- Menu movil --------------------------------------------------------- */

  var navBotones = document.querySelectorAll('[data-nav-toggle]');

  function navAbrir(button, abierto) {
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    panel.setAttribute('data-open', String(abierto));
    button.setAttribute('aria-expanded', String(abierto));
  }

  navBotones.forEach(function (button) {
    button.addEventListener('click', function () {
      navAbrir(button, button.getAttribute('aria-expanded') !== 'true');
    });
  });

  function navCerrarTodo() {
    navBotones.forEach(function (button) { navAbrir(button, false); });
  }

  /* --- La barra convertida en buscador --------------------------------------
     Los enlaces abren el formulario que tapa la barra en vez de ir a otra
     pagina. Sin este archivo siguen yendo a la pagina de busqueda.       */

  var buscador = document.querySelector('[data-buscador]');
  var campo = buscador && buscador.querySelector('.barrabuscar__campo');

  function buscarAbrir(abierto) {
    if (!buscador) return;
    buscador.setAttribute('data-open', String(abierto));
    if (abierto) campo.focus(); else campo.blur();
  }

  document.querySelectorAll('[data-buscar-abrir]').forEach(function (enlace) {
    enlace.addEventListener('click', function (evento) {
      if (!buscador) return;
      evento.preventDefault();
      navCerrarTodo();
      buscarAbrir(true);
    });
  });

  if (buscador) {
    buscador.querySelector('[data-buscar-cerrar]').addEventListener('click', function () {
      buscarAbrir(false);
    });
  }

  // Tocar fuera cierra lo que haya abierto, igual que Escape.
  document.addEventListener('click', function (evento) {
    if (!evento.target.closest('[data-nav-toggle], .navindex')) navCerrarTodo();
    if (!evento.target.closest('[data-buscador], [data-buscar-abrir]')) buscarAbrir(false);
  });

  document.addEventListener('keydown', function (evento) {
    if (evento.key !== 'Escape') return;
    navCerrarTodo();
    buscarAbrir(false);
  });

  /* --- Wordmark: fijo hasta el punto de parada ------------------------------
     El scroll NO ejecuta JavaScript: el logo solo cambia de modo, y de
     moverlo se encarga el navegador. El ancla usa rect.top + scrollY, que es
     invariante al scroll. El porque esta en CLAUDE.md.                   */

  var wordmark = document.querySelector('[data-wordmark]');
  var stopAt = document.querySelector('[data-wordmark-stop]');

  if (wordmark && stopAt) {
    var released = null;

    function place() {
      // El borde superior de la seccion en coordenadas de pagina. Al soltarse,
      // el logo esta centrado en pantalla y ese borde cae justo en el centro,
      // de modo que ambos coinciden y el cambio de modo no da ningun salto.
      var anchor = stopAt.getBoundingClientRect().top + window.scrollY;
      wordmark.style.setProperty('--wordmark-anchor', anchor + 'px');
    }

    function measure() {
      var next = stopAt.getBoundingClientRect().top <= window.innerHeight / 2;

      if (next) {
        // Se recalcula tambien estando ya soltado: el alto de la pagina
        // cambia segun se cargan las imagenes y el ancla se movia con el.
        place();
        wordmark.setAttribute('data-released', '');
      } else if (released !== false) {
        wordmark.removeAttribute('data-released');
      }

      released = next;
    }

    measure();

    // Solo avisa al cruzar el centro de la pantalla: cero trabajo por
    // fotograma. El margen inferior recorta la raiz a la mitad superior,
    // asi que el cruce que interesa es el del borde de arriba de la seccion.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(measure, { rootMargin: '0px 0px -50% 0px' }).observe(stopAt);
    }

    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);
  }

  /* --- Selectores de cantidad ---------------------------------------------- */

  document.querySelectorAll('[data-quantity]').forEach(function (widget) {
    var input = widget.querySelector('input');
    if (!input) return;

    input.addEventListener('change', function () {
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max'), 10);
      var value = parseInt(input.value, 10);

      if (isNaN(value)) value = min;
      if (!isNaN(max)) value = Math.min(max, value);
      input.value = String(Math.max(min, value));
    });

    widget.addEventListener('click', function (event) {
      var button = event.target.closest('[data-quantity-step]');
      if (!button) return;

      var step = parseInt(button.getAttribute('data-quantity-step'), 10);
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = (parseInt(input.value, 10) || min) + step;

      // El atributo max solo existe cuando hay inventario limitado.
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max)) next = Math.min(max, next);

      input.value = String(Math.max(min, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* --- Selector de variantes -----------------------------------------------
     El <select name="id"> es la fuente de verdad que se envia al carrito.
     Los radios solo lo pilotan, para que la pagina siga funcionando si este
     script no se ejecuta.                                                    */

  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    if (!form) return;

    var select = form.querySelector('[data-variant-select]');
    var priceTarget = document.getElementById(picker.getAttribute('data-price-target'));
    var submit = form.querySelector('[data-add-to-cart]');
    var quantity = form.querySelector('[data-quantity-input]');
    var stockNote = form.querySelector('[data-stock-note]');
    var stockTemplate = stockNote ? stockNote.getAttribute('data-template') : null;
    var variants;

    try {
      variants = JSON.parse(document.getElementById(picker.getAttribute('data-variants')).textContent);
    } catch (error) {
      return; // Sin datos de variantes, el <select> nativo sigue sirviendo.
    }

    function selectedOptions() {
      return Array.prototype.map.call(
        picker.querySelectorAll('input[type="radio"]:checked'),
        function (input) { return input.value; }
      );
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === options[index]; });
      });
    }

    // Con dos opciones, que una talla este disponible depende del color
    // elegido. Hay que recalcularlo en cada cambio, no solo al cargar.
    function refreshAvailability() {
      var chosen = selectedOptions();

      picker.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        var group = radio.closest('.variant-option');
        if (!group) return;

        var index = Array.prototype.indexOf.call(
          picker.querySelectorAll('.variant-option'), group
        );
        if (index < 0) return;

        var probe = chosen.slice();
        probe[index] = radio.value;

        var reachable = variants.some(function (variant) {
          return variant.available && variant.options.every(function (value, i) {
            return i === index ? value === radio.value : value === probe[i];
          });
        });

        // Nunca se deshabilita lo que el cliente tiene marcado: le dejaria la
        // seleccion en un estado que no puede deshacer.
        radio.disabled = !reachable && !radio.checked;
      });
    }

    function update() {
      var variant = findVariant(selectedOptions());
      refreshAvailability();

      if (!variant) {
        if (submit) {
          submit.setAttribute('disabled', 'disabled');
          submit.textContent = submit.getAttribute('data-unavailable-text');
        }
        return;
      }

      if (select) select.value = String(variant.id);

      if (priceTarget && variant.price_html) priceTarget.innerHTML = variant.price_html;

      // El inventario es por variante: al cambiar de talla hay que rehacer el
      // tope y recortar lo que ya hubiera escrito el cliente.
      if (quantity) {
        if (typeof variant.max === 'number' && variant.max > 0) {
          quantity.setAttribute('max', String(variant.max));
          if ((parseInt(quantity.value, 10) || 1) > variant.max) {
            quantity.value = String(variant.max);
          }
        } else {
          quantity.removeAttribute('max');
        }
      }

      if (stockNote) {
        if (typeof variant.max === 'number' && variant.max > 0 && stockTemplate) {
          stockNote.textContent = stockTemplate.replace('__n__', String(variant.max));
          stockNote.hidden = false;
        } else {
          stockNote.textContent = '';
          stockNote.hidden = true;
        }
      }

      if (submit) {
        if (variant.available) {
          submit.removeAttribute('disabled');
          submit.textContent = submit.getAttribute('data-default-text');
        } else {
          submit.setAttribute('disabled', 'disabled');
          submit.textContent = submit.getAttribute('data-sold-out-text');
        }
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
    update();
  });

  /* --- Carrito: recalcular al cambiar cantidades ---------------------------- */

  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('change', function (event) {
      if (event.target.matches('[name^="updates"]')) form.submit();
    });
  });
})();

